import { BidiModule } from "@angular/cdk/bidi";
import { OverlayModule } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NzOutletModule } from "ng-zorro-antd/core/outlet";
import { UiIconModule } from "../icon/icon.module";
import { UiMenuGroupComponent } from "./components/menu-group/menu-group.component";
import { UiSubmenuInlineChildComponent } from "./components/submenu-inline-child/submenu-inline-child.component";
import { UiSubmenuNoneInlineChildComponent } from "./components/submenu-non-inline-child/submenu-non-inline-child.component";
import { UiSubmenuTitleComponent } from "./components/submenu-title/submenu-title.component";
import { UiSubmenuComponent } from "./components/submenu/submenu-component";
import { UiMenuDividerDirective } from "./directives/menu-divider-directive";
import { UiMenuItemDirective } from "./directives/menu-item.directive";
import { UiMenuDirective } from "./menu.directive";

@NgModule({
  imports: [CommonModule, BidiModule, OverlayModule, NzOutletModule, UiIconModule],
  declarations: [
    UiMenuDirective,
    UiSubmenuComponent,
    UiMenuItemDirective,
    UiMenuGroupComponent,
    UiMenuDividerDirective,
    UiSubmenuTitleComponent,
    UiSubmenuInlineChildComponent,
    UiSubmenuNoneInlineChildComponent,
  ],
  exports: [UiMenuDirective, UiSubmenuComponent, UiMenuItemDirective, UiMenuGroupComponent, UiMenuDividerDirective],
})
export class UiMenuModule {}
